import { jasBoardVerificationHistoryStatusSchema } from '../../../../backend/features/jas-boards/shared';
import { useCredentialingTranslation } from '../../../../ui/hooks';
import { Typography } from '@mui/material';
import { differenceInDays, format } from 'date-fns';
import React from 'react';
import { JasBoardStatusLabelIcon } from '../components/JasBoardStatusLabelIcon';
const dateFmt = 'yyyy-MM-dd';
const dateTimeFmt = 'yyyy-MM-dd HH:mm:ss';
export function useJasBoardVerificationHistoryColumns() {
    const { t } = useCredentialingTranslation();
    const columns = [
        {
            headerLabel: t('table.jasBoardStatusHistory.labels.lastUpdated'),
            sortKey: 'name',
            cellFunction: ({ columns }) => columns.lastUpdatedAt ? React.createElement(Typography, { variant: 'body2' }, format(new Date(columns.lastUpdatedAt), dateFmt)) : null,
        },
        {
            headerLabel: t('table.jasBoardStatusHistory.labels.status'),
            cellFunction: ({ columns }) => React.createElement(JasBoardStatusLabelIcon, { status: columns.status }),
        },
        {
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
            },
            headerLabel: t('table.jasBoardStatusHistory.labels.notes'),
            cellFunction: ({ columns }) => {
                if (!columns.lastCheckedAt)
                    return null;
                const result = jasBoardVerificationHistoryStatusSchema.safeParse(columns.status);
                if (!result.success)
                    return null;
                let statusInfo;
                if (columns.calculateAge && columns.lastUpdatedAt) {
                    const status = t(`table.jasBoardStatusHistory.status.${result.data}`);
                    const dataAge = calculateAge(new Date(columns.lastUpdatedAt), new Date(columns.lastCheckedAt));
                    statusInfo = t('table.jasBoardStatusHistory.labels.dataAge', {
                        status,
                        count: dataAge,
                    });
                }
                else {
                    statusInfo = t(`table.jasBoardStatusHistory.labels.dataStatus.${result.data}`);
                }
                return React.createElement(Typography, { variant: 'body2' }, statusInfo);
            },
        },
        {
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
            },
            headerLabel: t('table.jasBoardStatusHistory.labels.lastChecked'),
            cellFunction: ({ columns }) => columns.lastCheckedAt ? React.createElement(Typography, { variant: 'body2' }, format(columns.lastCheckedAt, dateTimeFmt)) : null,
        },
    ];
    return { columns };
}
export const calculateAge = (startDate, endDate) => {
    const daysDifference = Math.abs(differenceInDays(endDate, startDate));
    return daysDifference;
};
